export default {
  //#region : Toast Handling :
  /**
   * Main Toast
   */
  showToast: (state, toast) => {
    const { color, timeout, message } = toast;

    state.toast = {
      message,
      color,
      timeout,
      show: true
    };
  },
  hideToast: (state) => {
    state.toast.show = false;
  },
  resetToast: (state) => {
    state.toast = {
      show: false,
      color: 'black',
      message: '',
      timeout: 3000
    };
  },
  //#endregion

  //#region : Plain Dialog Handling :
  /**
   * Shows or hides plainDialog message
   * @param {*} state
   * @param {*} showPlainDialog
   */
  showPlainDialog: (state, showPlainDialog) => {
    state.plainDialog.show = showPlainDialog;
  },
  /**
   * Sets plainDialog values in state
   * @param {*} state
   * @param {*} sigMessageModel
   */
  setPlainDialog: (state, sigMessageModel) => {
    state.plainDialog.message = sigMessageModel.message;
    state.plainDialog.messageTitle = sigMessageModel.messageTitle;
    state.plainDialog.buttonArray = [];
    if (sigMessageModel.buttonArray) {
      sigMessageModel.buttonArray.forEach((button) => {
        state.plainDialog.buttonArray.push(button);
      });
    }
  },
  //#endregion

  //#region : Sig Handling :
  /**
   * Shows or hides sig message
   * @param {*} state
   * @param {*} showSig
   */
  showSig: (state, showSig) => {
    state.sig.show = showSig;
  },
  /**
   * Sets sig values in state
   * @param {*} state
   * @param {*} sig
   */
  setSig: (state, sigMessageModel) => {
    state.sig.id = sigMessageModel.id;
    state.sig.messageTitle = sigMessageModel.messageTitle;
    state.sig.message = sigMessageModel.message;
    state.sig.buttonArray = [];
    state.sig.inputModels = sigMessageModel.inputModels || [];
    if (sigMessageModel.buttonArray) {
      sigMessageModel.buttonArray.forEach((button) => {
        state.sig.buttonArray.push(button);
      });
    }
  },
  //#endregion

  //#region : Authentication :
  /**
   * Sets the value of showLoginDialog in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {boolean} value - The new value for showLoginDialog.
   */
  setShowLoginDialog(state, show) {
    state.showLoginDialog = show;
  },
  /**
   * Sets the value of showCreateAccountDialog in the state.
   * @param {*} state
   * @param {*} show
   */
  setShowCreateAccountDialog(state, show) {
    state.showCreateAccountDialog = show;
  },
  /**
   * Sets the value of forgotPasswordDialog in the state.
   * @param {*} state
   * @param {*} show
   */
  setShowForgotPasswordDialog(state, show) {
    state.showForgotPasswordDialog = show;
  },
  /**
   * Sets the value of authenticating in the state.
   * @param {*} state
   * @param {*} authenticating
   */
  setAuthenticating: (state, authenticating) => {
    state.authenticating = authenticating;
  },
  /**
   * Sets user data in state
   * @param {*} state
   * @param {*} user
   */
  setUser: (state, user) => {
    state.user = {
      email: user.email,
      isGuest: user.isGuest,
      isUser: user.isUser,
      id: user.id,
      guid: user.guid,
      firstName: user.firstName,
      lastName: user.lastName
    };
  }
  //#endregion
};
